<template>
  <div>
    <div>
      <div class="c-card-body">
        <datatable
          ref="datatable"
          module="commission-config"
          :title="title"
          :url="url"
          :columns="columns"
          :on-click-create="onClickCreate"
          :on-click-update="onClickUpdate"
          :on-click-delete="onClickDelete"
          :action-width="180"
        >
        <template v-slot:[`item.min_value`]="{ item }">
          <div>
            Rp {{ new Intl.NumberFormat("id-ID").format(item.min_value) }}
          </div>          
        </template>
        <template v-slot:[`item.max_value`]="{ item }">
          <div>
            Rp {{ new Intl.NumberFormat("id-ID").format(item.max_value) }}
          </div>          
        </template>
      </datatable>
      </div>
    </div>
    <form-action ref="form" module="commission-config" :success="formSuccess" />
    <delete-dialog
      ref="delete"
      url="commission-config"
      :success="deleteSuccess"
    ></delete-dialog>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Datatable from "@/view/component/Datatable.vue";
import DeleteDialog from "@/view/component/DeleteDialog.vue";
import FormAction from "./Form";

export default {
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Komisi", route: "" },
      { title: "Konfigurasi Komisi" }
    ]);
  },
  data() {
    return {
      title: "Konfigurasi Komisi",
      url: "commission-config/data",
      columns: [
        {
          value: "id"
        },
        {
          text: "Role",
          value: "role_name",
          sortable: true,
          searchable: true
        },
        {
          text: "Config Type",
          value: "config_type",
          sortable: true,
          searchable: true
        },
        {
          text: "Min Value",
          value: "min_value",
          sortable: true,
          searchable: false
        },
        {
          text: "Max Value",
          value: "max_value",
          sortable: true,
          searchable: false
        },
        {
          text: "Percentage",
          value: "percentage",
          sortable: true,
          searchable: false
        },
        {
          text: "Fixed Amount",
          value: "fixed_amount",
          sortable: true,
          searchable: false
        },
        {
          text: "Description",
          value: "description",
          sortable: false,
          searchable: false
        }
      ]
    };
  },
  methods: {
    onClickCreate() {
      this.$refs.form.open();
    },
    onClickUpdate(item) {
      this.$refs.form.open(item.id);
    },
    onClickDelete(item) {
      this.$refs.delete.open(item.id);
    },
    formSuccess() {
      this.$refs.datatable.getData();
    },
    deleteSuccess() {
      this.$refs.datatable.getData();
    }
  },
  components: {
    Datatable,
    DeleteDialog,
    FormAction
  }
};
</script>
